<template>
  <v-container>
    <h1>Update Empty Ratings</h1>

    <progress-component script="UpdateEmptyRating"></progress-component>
  </v-container>
</template>

<script>
import ProgressComponent from '../components/ProgressComponent.vue';

export default {
  name: 'UpdateEmptyRatings',
  components: { ProgressComponent },
};
</script>
